import React from 'react';
import Header from '../../Universal/Header'
import Footer from '../../Universal/Footer'
import OurMember from '../Alumni/OurMember';
import HeroBanner from './HeroBanner';
import AboutInfoAccordion from '../About/AboutInfoAccordion';
import Memories from '../About/Memories';
import GallerySection from '../Gallery/GallerySection';
import NoticeSection from './NoticeSection';
import NewsSection from './NewsSection';
import CampusCareer from './CampusCareer';
import HomePopupSection from './HomePopupSection';

export default function Home() {
    return (
        <>
            <Header />
            <HeroBanner />
            <Memories />
            <AboutInfoAccordion />
            <NoticeSection />
            <NewsSection />
            <CampusCareer />
            <GallerySection />
            <OurMember />
            <Footer />

            {/* Homepage Popup - managed from admin panel */}
            <HomePopupSection />
        </>
    )
}